import { Action} from '@ngrx/store';
export const UI_START_LOADING = "[UI] stop Loading";
export const UI_STOP_LOADING = "[UI] Start Loading";

export class  StopLoading  implements Action{
    readonly type =UI_STOP_LOADING
};

export class StartLoading implements Action {

    readonly type = UI_START_LOADING;
};

export type  uiActions =  StartLoading | StopLoading;